import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Spinner, Typography } from "@material-tailwind/react";

import OpenModal from "../../../common/actions/OpenModal";
import { registerConference } from "../../../redux/actions/conference_action";

function ConferenceRegister({ item, disabled = false }) {
  const [loading, setLoading] = useState(false);
  const [virtualLoading, setVirtualLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [value, setValue] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleModal = (participationType) => {
    localStorage.removeItem("services");
    setValue(participationType);
    setShowModal((prev) => !prev);
  };

  const handleRegister = async (participationType) => {
    if (participationType === "In-Person") {
      setLoading(true);
    } else {
      setVirtualLoading(true);
    }

    const response = await dispatch(
      registerConference({
        ...item,
        sub_type: participationType,
      })
    );

    setLoading(false);
    setVirtualLoading(false);
    setShowModal(false);

    if (response?.error) {
      return;
    }

    const formData = response?.data?.conference?.[0];

    if (!formData) {
      return;
    }

    if (formData.exempt) {
      window.location.reload();
      return;
    }

    navigate("/home/conference/invoice", {
      state: { formData },
    });
  };

  return (
    <>
      <div className="flex flex-col gap-4 md:flex-row md:items-center mb-2">
        <Button
          color="green"
          onClick={() => handleModal("In-Person")}
          fullWidth
          size="lg"
          disabled={disabled || loading || virtualLoading}
        >
          {loading ? (
            <Spinner color="white" />
          ) : (
            <>
              Click Here for <span className="text-3xl">In-Person</span>{" "}
              Participation
            </>
          )}
        </Button>

        <Button
          color="light-blue"
          onClick={() => handleModal("Virtual")}
          fullWidth
          disabled={disabled || loading || virtualLoading}
        >
          {virtualLoading ? (
            <Spinner color="white" />
          ) : (
            <>
              Click Here for <span className="text-3xl">Virtual</span>{" "}
              Participation
            </>
          )}
        </Button>
      </div>

      {showModal && (
        <OpenModal
          open={showModal}
          handler={() => handleModal(value)}
          title="Confirm Participation"
          loading={loading || virtualLoading}
          actionTitle="Proceed"
          handleSubmit={() => handleRegister(value)}
          disable={loading || virtualLoading}
          children={
            <div className="flex flex-col gap-4">
              <Typography color="black" className="text-xl">
                Please confirm <span className="font-bold">{value}</span>{" "}
                Participation?
              </Typography>
            </div>
          }
        />
      )}
    </>
  );
}

export default ConferenceRegister;
